// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".image-column-slider").forEach((slideContainer) => {
//       var nextBtn = slideContainer.querySelector(".next-ar");
//       var prevBtn = slideContainer.querySelector(".prev-ar");

//       if (nextBtn && prevBtn) {
//         var slidesWidth = slideContainer.querySelector(".column-slide").offsetWidth;
//         var scrollsAmount = slidesWidth + 10;

//         nextBtn.addEventListener("click", () => {
//           slideContainer.scrollBy({
//             left: scrollsAmount,
//             behavior: "smooth",
//           });
//         });

//         prevBtn.addEventListener("click", () => {
//           slideContainer.scrollBy({
//             left: -scrollsAmount,
//             behavior: "smooth",
//           });
//         });
//       } else {
//         console.error("Next or Previous button not found in this slider:", slideContainer);
//       }
//     });
// });



document.addEventListener("DOMContentLoaded", () => {
  const initializeSlider = () => {
    document.querySelectorAll(".image-column-slider").forEach((slideContainer) => {
      const nextBtn = slideContainer.querySelector(".next-ar");
      const prevBtn = slideContainer.querySelector(".prev-ar");
      const slides = slideContainer.querySelectorAll(".column-slide");

      // Only activate slider below 991px
      if (window.innerWidth <= 991) {
        let slidesToShow = 1; // Always 1 slide on mobile
        const slideWidth = slideContainer.offsetWidth / slidesToShow;

        slides.forEach((slide) => {
          slide.style.minWidth = `${slideWidth}px`;
        });

        const scrollAmount = slideWidth + 10;

        nextBtn.addEventListener("click", () => {
          slideContainer.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
          });
        });

        prevBtn.addEventListener("click", () => {
          slideContainer.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
          });
        });
      } else {
        // Reset slider on larger screens
        slides.forEach((slide) => {
          slide.style.minWidth = "unset";
        });
      }
    });
  };

  // Run on load
  initializeSlider();

  // Re-check on resize
  window.addEventListener("resize", () => {
    initializeSlider();
  });
});
